import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyASlpfwE_imuJx5PXVqsDPzzWJqQR0nIgg",
  authDomain: "swift-titles.firebaseapp.com",
  projectId: "swift-titles",
  storageBucket: "swift-titles.appspot.com",
  messagingSenderId: "608127632961",
  appId: "1:608127632961:web:a002562c4ec55cf81428c0",
  measurementId: "G-JE6STE5XE9"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);